import { IViewItemAnalytics, IAddToCartAnalytics, IAddToCartItem } from './types';

interface SingleItemOptions {
  price: number;
  quantity: number;
}

interface MultipleItemSelection {
  price: number;
  quantity: number;
  itemVariant: string;
}

function buildSingleItem(
  baseItemAnalytics: IViewItemAnalytics | null | undefined,
  options: SingleItemOptions,
): IAddToCartAnalytics | null {
  if (!baseItemAnalytics?.items?.[0]) {
    return null;
  }

  const baseItem = baseItemAnalytics.items[0];
  const { price, quantity } = options;

  const item: IAddToCartItem = {
    ...baseItem,
    price,
    quantity,
  };

  return {
    currency: baseItemAnalytics.currency,
    value: Math.round(price * quantity * 100) / 100,
    items: [item],
  };
}

function buildMultipleItems(
  baseItemAnalytics: IViewItemAnalytics | null | undefined,
  selections: MultipleItemSelection[],
): IAddToCartAnalytics | null {
  if (!baseItemAnalytics?.items?.[0]) {
    return null;
  }

  if (!selections || selections.length === 0) {
    return null;
  }

  const baseItem = baseItemAnalytics.items[0];

  const items: IAddToCartItem[] = selections.map((selection) => ({
    ...baseItem,
    price: selection.price,
    quantity: selection.quantity,
    item_variant: selection.itemVariant,
  }));

  const value = Math.round(
    selections.reduce(
      (sum, selection) => sum + selection.price * selection.quantity,
      0,
    ) * 100,
  ) / 100;

  return {
    currency: baseItemAnalytics.currency,
    value,
    items,
  };
}

export default { buildSingleItem, buildMultipleItems };
